import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RastreadorModeloService {
  private url_grupo_2e: string = environment.g2e_api;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
    }),
  }

  constructor(private http: HttpClient) { }

  public async create(data: any): Promise<any> {
    return await this.http
      .post<any>(`${this.url_grupo_2e}rastreador-modelo`, data, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async findAll(): Promise<Array<any>> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador-modelo`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async findOne(id: number): Promise<any> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}rastreador-modelo/${id}`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async update(id: number, data: any): Promise<any> {
    return await this.http
      .patch<any>(`${this.url_grupo_2e}rastreador-modelo/${id}`, data, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async remove(id: number): Promise<any> {
    return await this.http
      .delete<any>(`${this.url_grupo_2e}rastreador-modelo/${id}`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }
}
